var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgApproveReopening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.615,
    height: 17.972,
    viewBox: "0 0 13.615 17.972"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-approve-reopening_svg__cls-2{fill:none;stroke:#987101;stroke-linecap:round;stroke-width:1.6px;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening_svg__ICN_Redeschide_Enabled",
    transform: "translate(121 1246.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening_svg__Rectangle_255",
    "data-name": "Rectangle 255",
    transform: "translate(-121 -1239.876)",
    stroke: "#987101",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.615,
    height: 11.538,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 12.015,
    height: 9.938,
    rx: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-reopening_svg__Path_825",
    "data-name": "Path 825",
    className: "kpmg-approve-reopening_svg__cls-2",
    d: "M-118.058-1241.133v-2.318a3.827 3.827 0 013.794-3.758 3.684 3.684 0 013.794 2.874",
    transform: "translate(0 1.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-reopening_svg__Path_1006",
    "data-name": "Path 1006",
    className: "kpmg-approve-reopening_svg__cls-2",
    d: "M-3652.132-18359.316l2.837 2.836 4.826-4.826",
    transform: "translate(3534 17124.846)"
  }))));
}

export default SvgKpmgApproveReopening;